
import Vue from "vue";

export default Vue.extend({
  name: "PaymentSuccess",

  data: () => ({
    timer: null as any,
    usmfLogo: require("@/assets/images/usmf-logo.png"),
  }),

  mounted() {
    this.timer = setTimeout(() => {
      this.toMain();
    }, 10000);
  },

  methods: {
    toMain() {
      clearTimeout(this.timer);
      this.$router.push("/auth/login");
    },
  },
});
